import produce from 'immer';

import * as types from './types';

const initialState = {
  currency: '$',
  locale: 'US'
};

/* eslint-disable consistent-return */
/* eslint-disable default-case */
/* eslint-disable no-param-reassign */
const reducer = produce((draft, action) => {
  switch (action.type) {
    case types.GEO_SET_LOCALE:
      draft.locale = action.locale;
      break;

    case types.GEO_SET_CURRENCY:
      draft.currency = action.currency;
      break;
  }
}, initialState);

export default reducer;
